module.exports = __webpack_public_path__ + "static/img/warning.020c0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warning.png
// module id = ihMV
// module chunks = 1